import { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { GiFamilyHouse } from "react-icons/gi";
import { db } from '../../services/firebaseConnection';
import { addDoc, collection, getDocs } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function Igreja() {
  const [nome, setNome] = useState('');
  const [cidade, setCidade] = useState([]);
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [diasCulto, setDiasCulto] = useState([{ dia: '', horario: '' }]);
  const [rdj, setRDJ] = useState('nao');
  const [diasRDJ, setDiasRDJ] = useState([{ dia: '', horario: '' }]);
  const [atriu, setAtriu] = useState('Átrio');
  const [corredor, setCorredor] = useState('Pedidos de Oração');
  const [banheiro, setBanheiro] = useState('Sanitário');
  const [estacionamento, setEstacionamento] = useState('Sanitário');
  const [som, setSom] = useState('Som');

  const navigate = useNavigate();

  useEffect(() => {
    const getCidadeFromDatabase = async () => {
      try {
        const cidadeSnapshot = await getDocs(collection(db, 'Cidade'));
        const cidadeData = cidadeSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCidade(cidadeData);
      } catch (error) {
        console.error('Erro ao buscar cidade:', error);
      }
    };

    getCidadeFromDatabase();
  }, []);

  const adicionarDiaCulto = () => {
    setDiasCulto([...diasCulto, { dia: '', horario: '' }]);
  };

  const handleDiaCultoChange = (index, campo, valor) => {
    const novosDiasCulto = [...diasCulto];
    novosDiasCulto[index][campo] = valor;
    setDiasCulto(novosDiasCulto);
  };

  const removerDiaCulto = (index) => {
    const novosDiasCulto = [...diasCulto];
    novosDiasCulto.splice(index, 1);
    setDiasCulto(novosDiasCulto);
  };

  const adicionarDiaRDJ = () => {
    setDiasRDJ([...diasRDJ, { dia: '', horario: '' }]);
  };

  const handleDiaRDJChange = (index, campo, valor) => {
    const novosDiasRDJ = [...diasRDJ];
    novosDiasRDJ[index][campo] = valor;
    setDiasRDJ(novosDiasRDJ);
  };

  const removerDiaRDJ = (index) => {
    const novosDiasRDJ = [...diasRDJ];
    novosDiasRDJ.splice(index, 1);
    setDiasRDJ(novosDiasRDJ);
  };

  async function handleRegister(e) {
    e.preventDefault();

    if (nome !== '' && cidadeSelecionada !== '') {
      try {
        await addDoc(collection(db, 'Igreja'), {
          nome: nome,
          cidade: cidadeSelecionada,
          diasCulto: diasCulto,
          rdj: rdj,
          diasRDJ: diasRDJ,
          atriu: atriu, // Adicionado
          corredor: corredor, // Adicionado
          banheiro: banheiro, // Adicionado
          estacionamento: estacionamento, // Adicionado
          som: som, // Adicionado
        });

        setNome('');
        setDiasCulto([{ dia: '', horario: '' }]);
        setRDJ('nao');
        setDiasRDJ([{ dia: '', horario: '' }]);
        setCidadeSelecionada('');
        setAtriu('Átrio'); // Resetando valor inicial
        setCorredor('Pedidos de Oração'); // Resetando valor inicial
        setBanheiro('Sanitário'); // Resetando valor inicial
        setEstacionamento('Estacionamento'); // Resetando valor inicial
        setSom('Som'); // Resetando valor inicial
        toast.success('Igreja registrada!');
        navigate('/igreja');
      } catch (error) {
        console.error(error);
        toast.error('Erro ao fazer o cadastro.');
      }
    } else {
      toast.error('Preencha todos os campos!');
    }
  }


  return (
    <div>
      <Header />

      <div className="content">
        <Title name="Casa de Oração">
          <GiFamilyHouse size={25} />
        </Title>

        <div className="container">
          <form className="form-profile" onSubmit={handleRegister}>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome da Casa de Oração"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />

            <label>Tem Reunião de Jovens e Menores?</label>
            <select
              value={rdj}
              onChange={(e) => setRDJ(e.target.value)}
            >
              <option value="sim">Sim</option>
              <option value="nao">Não</option>
            </select>

            {/* Exibir os diasRDJ apenas se o valor de rdj for "sim" */}
            {rdj === 'sim' && (
              <div>
                {diasRDJ.map((dia, index) => (
                  <div className='diasCultos' key={index}>
                    <label>Dia de RDJ {index + 1}</label>
                    <select
                      value={dia.dia}
                      onChange={(e) =>
                        handleDiaRDJChange(index, 'dia', e.target.value)
                      }
                    >
                      <option value="Domingo">Domingo</option>
                      <option value="Segunda">Segunda</option>
                      <option value="Terca">Terça</option>
                      <option value="Quarta">Quarta</option>
                      <option value="Quinta">Quinta</option>
                      <option value="Sexta">Sexta</option>
                      <option value="Sabado">Sábado</option>
                    </select>
                    <input
                      type="time"
                      value={dia.horario}
                      onChange={(e) =>
                        handleDiaRDJChange(index, 'horario', e.target.value)
                      }
                    />

                    <button type="button" onClick={() => removerDiaRDJ(index)}>
                      Remover
                    </button>
                  </div>
                ))}
                <button className='addCulto' type="button" onClick={adicionarDiaRDJ}>
                  Adicionar Dia de RDJ
                </button>
              </div>
            )}

            <label>Cidade</label>
            <select
              value={cidadeSelecionada}
              onChange={(e) => setCidadeSelecionada(e.target.value)}
            >
              <option value="">Selecione uma cidade</option>
              {cidade.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>
                  {cidade.nome}
                </option>
              ))}
            </select>

            <div>
              {diasCulto.map((dia, index) => (
                <div className='diasCultos' key={index}>
                  <label>Dia de Culto {index + 1}</label>
                  <select
                    value={dia.dia}
                    onChange={(e) =>
                      handleDiaCultoChange(index, 'dia', e.target.value)
                    }
                  >
                    <option value="Domingo">Domingo</option>
                    <option value="Segunda">Segunda</option>
                    <option value="Terca">Terça</option>
                    <option value="Quarta">Quarta</option>
                    <option value="Quinta">Quinta</option>
                    <option value="Sexta">Sexta</option>
                    <option value="Sabado">Sábado</option>
                  </select>
                  <input
                    type="time"
                    value={dia.horario}
                    onChange={(e) =>
                      handleDiaCultoChange(index, 'horario', e.target.value)
                    }
                  />

                  <button type="button" onClick={() => removerDiaCulto(index)}>
                    Remover
                  </button>
                </div>
              ))}
              <button className='addCulto' type="button" onClick={adicionarDiaCulto}>
                Adicionar Dia de Culto
              </button>
            </div>

            <label>Personalizar nome dos locais?</label>
            <input
              type="text"
              placeholder="Nome do Átrio"
              value={atriu}
              onChange={(e) => setAtriu(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Pedidos de Oração"
              value={corredor}
              onChange={(e) => setCorredor(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Sanitário"
              value={banheiro}
              onChange={(e) => setBanheiro(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Estacionamento"
              value={estacionamento}
              onChange={(e) => setEstacionamento(e.target.value)}
            />
            <input
              type="text"
              placeholder="Nome do Som"
              value={som}
              onChange={(e) => setSom(e.target.value)}
            />

            <button type="submit">Salvar</button>
          </form>
        </div>
      </div>
    </div>
  );
}
